"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Cell_1 = require("./Cell");
const Row = ({ preview, columns, item, selected }) => {
    if (preview && columns.length > 0) {
        return (0, jsx_runtime_1.jsx)(Cell_1.Cell, { selected: selected, column: columns[0], item: item }, void 0);
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: columns.map((column, index) => ((0, jsx_runtime_1.jsx)(Cell_1.Cell, { selected: selected, item: item, column: column }, index))) }, void 0));
};
exports.Row = Row;
//# sourceMappingURL=Row.js.map